import React from "react";
import { Trans, withTranslation } from "react-i18next";
import { Multiselect } from "multiselect-react-dropdown";
import { Translation } from "react-i18next";
import AddIcon from "../UIComponents/AddIcon";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import {
  getShipManagementDetails,
  getShipManagementList,
  getShipEquipmentDetails,
} from "../Actions/ShipManagementAPI";
import {
  getFlagList,
  getClientUsersList,
  getClassList,
  getClientNameList,
  getTypeofShipList,
  getApproverNameList,
  getCoordinatorNameList
} from "../Actions/helpersAPI";
import axios from "axios";
import API from "../helpers/api";
import { postFirePlanAttachment, postShipContractAttachment, deleteAttachmentInBucket } from "../Actions/CommonAPI";
import Moment from "moment";
import DatePicker from "react-datepicker";
import { toast } from "react-toastify";
import swal from "sweetalert";
import $ from "jquery";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import { OverlayTrigger, Popover } from "react-bootstrap";
import i18n from "./DropdownLanguage/i18n";

var fileDatas = [];
let searchData = {
  ShipName: "",
  ImoNo: "",
  Flag: "",
  Class: "",
  Grt: "",
  status: "active",
  DeadWeight: "",
  PageNumber: 1,
  PageSize: 20,
};
let currentUser = JSON.parse(localStorage.getItem("currentUser"));
class ShipManagementEditItem extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      shipInfo: {
        shipId: 0,
        contractId: 0,
        shipName: "",
        flag: "",
        class: "",
        firePlanName: "",
        firePlanGUID: "",
        nameOfContract: "",
        contractGUID: "",
        grt: "",
        imoNo: "",
        status: "",
        deadWeight: "",
        dateOfBuild: "",
        enrollmentDate: "",
        approverId: 0,
        typeOfShip: "",
        shipEmail: "",
        invoiceForwardingEmail: "",
        vesselGroupEmail: "",
        phone1: "",
        phone2: "",
        companyName: "",
        contractName: "",
        contractStatus: "pending",
        modifiedBy: currentUser.name,
        isDeleted: false,
        shipUsers: [],
        isContract: false,
        grantAdmins: []
      },
      selectClass: [],
      maxClassselect: 2,
      file: "",
      fileName: "",
      attachment: "",
      attachmentName: "",
      fleetmanager: [],
      superintendent: [],
      technicalexecutive: [],
      grantAdmins: [],
      pending: false,
      active: false,
      terminated: false,
      Equipmentlist: [],
      DatePickerIsOpen: "",
      EnrollmentDatePickerIsOpen: false,
    };
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleCompanyInputChange = this.handleCompanyInputChange.bind(this);
    this.handleContractInputChange = this.handleContractInputChange.bind(this);
    this.UpdateShip = this.UpdateShip.bind(this);
    this.handleDateofBuild = this.handleDateofBuild.bind(this);
    this.openEnrollmentDatePicker = this.openEnrollmentDatePicker.bind(this);
    this.handleEnrollmentDate = this.handleEnrollmentDate.bind(this);
    this.openDatePicker = this.openDatePicker.bind(this);
    this.handleBlur = this.handleBlur.bind(this);
    this.ClearInput = this.ClearInput.bind(this);
    this.onSelectChange = this.onSelectChange.bind(this);
    this.onRemoveChange = this.onRemoveChange.bind(this);
  }

  componentDidMount() {
    const { dispatch, companyName, match } = this.props;
    dispatch(getFlagList());
    dispatch({ type: "SubBannerTitle", data: "Ship Management" });
    dispatch(getClassList("class"));
    dispatch(getClientNameList());
    dispatch(getClientUsersList(companyName));
    dispatch(getTypeofShipList("typeofship"));
    dispatch(getShipManagementDetails(match.params.id));
    dispatch(getApproverNameList());
    dispatch(getCoordinatorNameList());
    dispatch(getShipEquipmentDetails(match.params.id));
  }
  static getDerivedStateFromProps(nextProps, prevState) {
    const { EquipmentArray, FirePlanAttachment, ShipDetails, dispatch, ShipContractAttachment } =
      nextProps;
    if (ShipDetails && ShipDetails !== "") {
      prevState.shipInfo.shipId = ShipDetails.shipId;
      prevState.shipInfo.shipName = ShipDetails.shipName;
      prevState.shipInfo.imoNo = ShipDetails.imoNo;
      prevState.fileName = ShipDetails.firePlanName;
      prevState.shipInfo.firePlanName = ShipDetails.firePlanName;
      prevState.shipInfo.firePlanGUID = ShipDetails.firePlanGUID;
      prevState.attachmentName = ShipDetails.agreementName;
      prevState.shipInfo.nameOfContract = ShipDetails.agreementName;
      prevState.shipInfo.contractGUID = ShipDetails.agreementGUID;
      prevState.shipInfo.flag = ShipDetails.flag;
      prevState.selectClass = ShipDetails.class ? ShipDetails?.class?.map((r) => { return r }) : [];
      prevState.shipInfo.grt = ShipDetails.grt;
      prevState.shipInfo.approverId = ShipDetails?.approverId ? ShipDetails?.approverId : 0;
      prevState.shipInfo.typeOfShip = ShipDetails.typeOfShip;
      prevState.shipInfo.status = ShipDetails.status;
      prevState.shipInfo.dateOfBuild = Moment(
        new Date(Date.parse(ShipDetails.dateOfBuild))
      ).format("YYYY-MM-DD");
      prevState.shipInfo.enrollmentDate = ShipDetails.enrollmentDate ? Moment(
        new Date(Date.parse(ShipDetails.enrollmentDate))
      ).format("YYYY-MM-DD") : "";
      prevState.shipInfo.deadWeight = ShipDetails.deadWeight;
      prevState.shipInfo.shipEmail = ShipDetails.shipEmail;
      prevState.shipInfo.phone1 = ShipDetails.phone1;
      prevState.shipInfo.phone2 = ShipDetails.phone2;
      prevState.shipInfo.invoiceForwardingEmail =
        ShipDetails.invoiceForwardingEmail;
      prevState.shipInfo.vesselGroupEmail = ShipDetails.vesselGroupEmail;
      prevState.shipInfo.companyName = ShipDetails.companyName;
      prevState.shipInfo.contractName = ShipDetails.contractName;
      prevState.shipInfo.contractStatus = ShipDetails.contractStatus;
      prevState.shipInfo.contractId = ShipDetails.contractId
        ? ShipDetails.contractId
        : 0;
      prevState.fleetmanager = ShipDetails.fleetManager ?? [];
      prevState.superintendent = ShipDetails.technicalSuperintendent ?? [];
      prevState.technicalexecutive = ShipDetails.technicalExecutive ?? [];
      prevState.grantAdmins = ShipDetails.grantAdmins ?? [];
      if (ShipDetails.contractStatus === "active") {
        prevState.active = true;
      } else if (ShipDetails.contractStatus === "terminated") {
        prevState.terminated = true;
      } else if (ShipDetails.contractStatus === "pending") {
        prevState.pending = true;
      }
      // prevState.shipInfo.shipUsers = [
      //   {
      //     userName: ShipDetails.fleetManager,
      //     role: "fleetmanager",
      //   },
      //   {
      //     userName: ShipDetails.technicalSuperintendent,
      //     role: "superintendent",
      //   },
      //   {
      //     userName: ShipDetails.technicalExecutive,
      //     role: "technicalexecutive",
      //   },
      // ];
      prevState.shipInfo.isContract = ShipDetails.isContract;
      dispatch({ type: "getShipManagementDetailSuccess", data: "" });
    }

    if (EquipmentArray) {
      prevState.Equipmentlist = EquipmentArray;
    }
    if (FirePlanAttachment) {
      prevState.shipInfo.firePlanName = FirePlanAttachment.FileName;
      prevState.shipInfo.firePlanGUID = FirePlanAttachment.Guid;
      console.log("filename", prevState.fileName);
      console.log("fileinformation", FirePlanAttachment)
      dispatch({ type: "postFirePlanAttachmentUploadSuccess", data: null });
    }
    if (ShipContractAttachment) {
      prevState.shipInfo.nameOfContract = ShipContractAttachment.FileName;
      prevState.shipInfo.contractGUID = ShipContractAttachment.Guid;
      console.log("attachmentfilename", prevState.attachmentName);
      dispatch({ type: "postShipContractAttachmentUploadSuccess", data: null });
    }
    if (prevState.attachment !== "") {
      dispatch(postShipContractAttachment(prevState.attachment));
      prevState.attachment = "";
    }
    if (prevState.file !== "") {
      dispatch(postFirePlanAttachment(prevState.file));
      prevState.file = "";
    }
  }

  onSelectChange(item) {
    if (item.length <= 2) {
      this.state.selectClass = item;
      this.setState({});
    }
  }

  onRemoveChange(item) {
    this.state.selectClass = item;
    this.setState({});
  }
  UpdateShip() {
    const { dispatch, t } = this.props;
    
    if (
      this.state.shipInfo.shipEmail === "" ||
      this.state.shipInfo.enrollmentDate === "" ||
      this.state.shipInfo.dateOfBuild === "" ||
      this.state.shipInfo.shipName === "" ||
      this.state.shipInfo.companyName === "" ||
      this.state.shipInfo.imoNo === "" ||
      this.state.shipInfo.flag === "" ||
      this.state.selectClass.length === 0
    ) {
      this.state.shipInfo.shipEmail === ""
        ? $("#shipemail").addClass("Error-border")
        : $("#shipemail").removeClass("Error-border");
      this.state.shipInfo.shipName === ""
        ? $("#shipname").addClass("Error-border")
        : $("#shipname").removeClass("Error-border");
      this.state.shipInfo.enrollmentDate === ""
        ? $("#enrollmentdate").addClass("Error-border")
        : $("#enrollmentdate").removeClass("Error-border");
      this.state.shipInfo.dateOfBuild === ""
        ? $("#dateofbuild").addClass("Error-border")
        : $("#dateofbuild").removeClass("Error-border");
      this.state.shipInfo.companyName === ""
        ? $("#companyname").addClass("Error-border")
        : $("#companyname").removeClass("Error-border");
      this.state.shipInfo.imoNo === ""
        ? $("#imono").addClass("Error-border")
        : $("#imono").removeClass("Error-border");
      this.state.shipInfo.flag === ""
        ? $("#flagname").addClass("Error-border")
        : $("#flagname").removeClass("Error-border");
      this.state.selectClass.length === 0
        ? $("#selectclass").addClass("Error-border")
        : $("#selectclass").removeClass("Error-border");

      return;
    } else {
      $("#shipname").removeClass("Error-border");
      $("#enrollmentdate").removeClass("Error-border");
      $("#dateofbuild").removeClass("Error-border");
      $("#companyname").removeClass("Error-border");
      $("#shipemail").removeClass("Error-border");
      $("#imono").removeClass("Error-border");
      $("#flagname").removeClass("Error-border");
      $("#selectclass").removeClass("Error-border");
    }
    this.state.shipInfo.class = this.state.selectClass ? this.state.selectClass.toString() : "";
    const userRoles = [
      { userName: this.state.fleetmanager ? this.state.fleetmanager : null, role: "fleetmanager" },
      { userName: this.state.superintendent ? this.state.superintendent : null, role: "superintendent" },
      { userName: this.state.technicalexecutive ? this.state.technicalexecutive : null, role: "technicalexecutive" }
    ];
    let grandAdmins = this.state.grantAdmins.map((data) => ({
      id: data.id,
      name: data.name
    }))
    this.state.shipInfo.grantAdmins = grandAdmins;
    let userarray = [];
    this.state.fleetmanager.map((data, index) => {
      let userdata = { "userName": data, "role": 'fleetmanager' };
      userarray.push(userdata);
    })
    this.state.technicalexecutive.map((data, index) => {
      let userdata = { "userName": data, "role": 'technicalexecutive' };
      userarray.push(userdata);
    })
    this.state.superintendent.map((data, index) => {
      let userdata = { "userName": data, "role": 'superintendent' };
      userarray.push(userdata);
    })
    this.state.shipInfo.shipUsers = userarray;
    this.setState({})
    let url = `${API.getShipDetail}`;
    axios
      .put(url, this.state.shipInfo, {
        headers: {
          key: currentUser.accessToken,
        },
      })
      .then((response) => {
        // let equip = EquipmentArray.map(f => {
        //     let equipmentinfo = {
        //         shipId: f.shipId,
        //         equipmentId: f.equipmentId,
        //         shipEquipmentId: f.shipEquipmentId,
        //         equipment: f.equipment,
        //         manufracturingDate: f.manufracturingDate,
        //         make: f.make,
        //         model: f.model,
        //         quantity: f.quantity,
        //         serviceDetails: f.serviceDetails,
        //         modifiedBy: '',
        //         isDeleted: false
        //     }
        //     return equipmentinfo;
        // })
        // dispatch(UpdateEquipmentDetails(equip));

        if (fileDatas.length > 0) {
          this.props.dispatch(deleteAttachmentInBucket(fileDatas));
          fileDatas = [];
        }
        dispatch(getShipManagementList(searchData));
        this.CancelUpdateship();
        toast.success(`${t("CommonText.CommonUpdate")}`, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        dispatch({
          type: "PostShipDetailSuccess",
          data: response.data,
        });
        this.props.history.push("/Home/ShipManagement");
      })
      .catch((error) => {
        dispatch({
          type: "PostShipDetailFailure",
          data: "error",
        });
      });
    //    dispatch(postEquipmentDetails());
  }

  handleDateofBuild(date) {
    this.state.shipInfo.dateOfBuild = Moment(new Date(Date.parse(date))).format(
      "YYYY-MM-DD"
    );
    this.setState({
      DatePickerIsOpen: false,
    });
  }
  handleEnrollmentDate(date) {
    this.state.shipInfo.enrollmentDate = Moment(new Date(Date.parse(date))).format(
      "YYYY-MM-DD"
    );
    this.setState({
      EnrollmentDatePickerIsOpen: false,
    });
  }

  openDatePicker() {
    this.setState({
      DatePickerIsOpen: !this.state.DatePickerIsOpen,
    });
  }
  openEnrollmentDatePicker() {
    this.setState({
      EnrollmentDatePickerIsOpen: !this.state.EnrollmentDatePickerIsOpen,
    });
  }

  handleBlur() {
    this.setState({
      DatePickerIsOpen: false,
      EnrollmentDatePickerIsOpen: false,
    });
  }

  CancelUpdateship() {
    fileDatas = [];
    this.props.dispatch({ type: "ShowSidePan", data: false });
    this.props.history.push("/Home/ShipManagement");
  }

  handleInputChange(e) {
    const { t } = this.props;
    let nodeName = e.target.name;
    if (nodeName === "fileName") {
      let filename = e.target.files[0].name;
      var upload = filename.split(".").pop();
      if (upload.toLowerCase() === "pdf") {
        $("#FileErrMsg").text("");
        let regex = /^[0-9a-zA-Z\s\(\)\.\_\&\$\#\-\']+$/g;
        if (regex.test(filename)) {
          this.setState({
            FileUploadstatus: true,
            file: e.target.files[0],
            fileName: e.target.files[0].name,
          });
        } else {
          // swal(
          //   "Error!",
          //   "Please upload the file without special characters.",
          //   "warning");
          swal({
            title: t('SwalError.ErrorTitle'),
            text: t('SwalError.UploadFile'),
            icon: 'warning',
            buttons: {
              confirm: {
                text: t('confirmAlertMessage.Ok')
              }
            }
          });
          return;
        }
      } else {
        $("#FileErrMsg").text(`${t("ErrorMessage.Onlyptf")}`);
      }
    } else if (nodeName === "phone1") {
      const phone1 = e.target.validity.valid
        ? e.target.value
        : this.state.shipInfo.phone1;
      this.state.shipInfo[nodeName] = phone1;
      this.setState({});
    } else if (nodeName === "phone2") {
      const phone2 = e.target.validity.valid
        ? e.target.value
        : this.state.shipInfo.phone2;
      this.state.shipInfo[nodeName] = phone2;
      this.setState({});
    } else {
      this.state.shipInfo[nodeName] = e.target.value;
      this.setState({});
    }
  }
  handleContractInputChange(e) {
    let nodeName = e.target.name;
    if (nodeName === "active") {
      this.state.shipInfo.contractStatus = "active";
      this.setState({ active: true, pending: false, terminated: false });
    }
    if (nodeName === "terminated") {
      this.state.shipInfo.contractStatus = "terminated";
      this.setState({ active: false, pending: false, terminated: true });
    } else if (nodeName === "pending") {
      this.state.shipInfo.contractStatus = "pending";
      this.setState({ active: false, pending: true, terminated: false });
    }
  }
  handleAttachmentInputChange(e) {
    const { t } = this.props;
    let nodeName = e.target.name;
    if (nodeName === "attachmentName") {
      let filename = e.target.files[0].name;
      var upload = filename.split(".").pop();
      if (upload.toLowerCase() === "pdf") {
        $("#AttachmentErrMsg").text("");
        let regex = /^[0-9a-zA-Z\s\(\)\.\_\&\$\#\-\']+$/g;
        if (regex.test(filename)) {
          this.setState({
            ContractUploadstatus: true,
            attachment: e.target.files[0],
            attachmentName: e.target.files[0].name,
          });
        }
        else {
          // swal(
          //   "Error!",
          //   "Please upload the file without special characters.",
          //   "warning");
          swal({
            title: t('SwalError.ErrorTitle'),
            text: t('SwalError.UploadFile'),
            icon: 'warning',
            buttons: {
              confirm: {
                text: t('confirmAlertMessage.Ok')
              }
            }
          });
          return;
        }
      } else {
        $("#AttachmentErrMsg").text(`${t("ErrorMessage.Onlyptf")}`);
      }
    }
  }
  ClearInput() {
    //this.props.dispatch(deleteAttachmentInBucket(this.state.shipInfo.firePlanGUID,this.state.shipInfo.firePlanName));
    let obj = {
      filename: this.state.shipInfo.firePlanName,
      guid: this.state.shipInfo.firePlanGUID,
    }
    fileDatas.push(obj);
    this.state.file = "";
    this.state.fileName = "";
    this.state.shipInfo.firePlanName = "";
    this.state.shipInfo.firePlanGUID = "";
    this.setState({}, () => {
      // console.log("shipUpdate",this.state.shipInfo)
    });
  }
  ClearAttachmentInput() {
    //this.props.dispatch(deleteAttachmentInBucket(this.state.shipInfo.contractGUID,this.state.shipInfo.nameOfContract));
    let obj = {
      filename: this.state.shipInfo.nameOfContract,
      guid: this.state.shipInfo.contractGUID,
    }
    fileDatas.push(obj);
    this.state.attachment = "";
    this.state.attachmentName = "";
    this.state.shipInfo.nameOfContract = "";
    this.state.shipInfo.contractGUID = "";
    this.state.shipInfo.agreementGUID = "";
    this.state.shipInfo.agreementName = "";
    this.setState({}, () => {
      //  console.log("shipUpdate",this.state.shipInfo)
    });
  }

  handleContractCheckChange(event) {
    const { t } = this.props;
    let checkBool = event.target.checked;
    if (this.state.shipInfo?.isContract == true) {
      let url = `${API.VerifyContractShip}${this.state.shipInfo.shipId}`;
      axios.get(url)
        .then((response) => {
          if (response.data == false) {
            this.setState({
              shipInfo: {
                ...this.state.shipInfo,
                isContract: checkBool
              }
            })
          } else {
            // swal('Information!', 'There is an active contracts for this ship!', 'info');
            swal({
              title: t('SwalError.Information'),
              text: t('SwalError.ActiveContract'),
              icon: 'info',
              buttons: {
                confirm: {
                  text: t('confirmAlertMessage.Ok')
                }
              }
            });
          }
        })
        .catch((error) => {

        })
    } else {
      this.setState({
        shipInfo: {
          ...this.state.shipInfo,
          isContract: checkBool
        }
      })
    }
  }

  handleCompanyInputChange(e) {
    let nodeName = e.target.name;
    if (nodeName === "fleetmanager") {
      this.state[nodeName] = e.target.value;
      this.state.shipInfo.shipUsers.push({
        userName: e.target.value,
        role: "fleetmanager",
      });
    } else if (nodeName === "superintendent") {
      this.state[nodeName] = e.target.value;
      this.state.shipInfo.shipUsers.push({
        userName: e.target.value,
        role: "superintendent",
      });
    } else if (nodeName === "technicalexecutive") {
      this.state[nodeName] = e.target.value;
      this.state.shipInfo.shipUsers.push({
        userName: e.target.value,
        role: "technicalexecutive",
      });
    } else if (nodeName === "companyName") {
      this.state.fleetmanager = [];
      this.state.superintendent = [];
      this.state.technicalexecutive = [];
      this.props.dispatch(getClientUsersList(e.target.value));
      this.state.shipInfo[nodeName] = e.target.value;
    }
    if (nodeName === "grantAdminId" || nodeName === "approverId") {
      this.state.shipInfo[nodeName] = e.target.value;
    }
    this.setState({});
  }
  handleCompanyInputChange1(nodeName, item) {
    if (nodeName === "fleetmanager") {
      this.state[nodeName] = item;
    } else if (nodeName === "superintendent") {
      this.state[nodeName] = item;
    } else if (nodeName === "technicalexecutive") {
      this.state[nodeName] = item;
    }
    else if (nodeName == "grantAdmins") {
      this.state[nodeName] = item;
    }
    this.setState({}, () => {
      let userarray = [];
      this.state.fleetmanager.map((data, index) => {
        let userdata = { "userName": data, "role": 'fleetmanager' };
        userarray.push(userdata);
      })
      this.state.technicalexecutive.map((data, index) => {
        let userdata = { "userName": data, "role": 'technicalexecutive' };
        userarray.push(userdata);
      })
      this.state.superintendent.map((data, index) => {
        let userdata = { "userName": data, "role": 'superintendent' };
        userarray.push(userdata);
      })
      console.log(userarray);
    });
  }
  renderdelete(props) {
    return (
      <Popover id="history-tooltip" {...props}>
        <Popover.Content>
          <label style={{ padding: "0px 10px" }}>{this.props.t("ShipManagementContent.DeleteEquipments")}</label>
        </Popover.Content>
      </Popover>
    );
  }
  renderedit(props) {
    return (
      <Popover id="history-tooltip" {...props}>
        <Popover.Content>
          <label style={{ padding: "0px 10px" }}>{this.props.t("ShipManagementContent.EditEquipmentsDetails")}</label>
        </Popover.Content>
      </Popover>
    );
  }


  render() {
    const {
      showSidePane,
      flagList,
      ClientUsersList,
      ClientNameList,
      ClassList,
      ApproverList,
      CoordinatorList,
      TypeofShipList,
      t
    } = this.props;
    return (
      <div className="full-height">
        <div className="row pt-3">
          <div className="col-lg-12">
            <div className="panel-box">
              <div className="search-filter-box">
                <div
                  className="card mt-2 MM-card-header mb-0"
                  style={{ backgroundColor: "white" }}
                >
                  <div
                    className="card-body"
                    style={{
                      padding: "0rem",
                      backgroundColor: "#1a3464",
                      color: "white",
                    }}
                  >
                    <h5
                      className="card-title ml-2 mt-2"
                      style={{ color: "092a51" }}
                    >
                      {t("ShipManagementContent.BasicDetails")}
                    </h5>
                  </div>
                </div>
                <div className="row search-filter-box">
                  <div className={showSidePane ? "col-lg-6 mt-1" : "col-lg-4 mt-1"}>
                    <label className="form-label fontstyle required">{t("content.Shipname")}</label>
                    <br></br>
                    <input
                      className="form-control"
                      id="shipname"
                      type="text"
                      name="shipName"
                      placeholder={t("content.Shipname")}
                      value={this.state.shipInfo.shipName}
                      onChange={(e) => this.handleInputChange(e)}
                    ></input>
                  </div>
                  <div className={showSidePane ? "col-lg-6 mt-1" : "col-lg-4 mt-1"}>
                    <label className="form-label required">{t("content.IMOno")}</label>
                    <br></br>
                    <input
                      className="form-control"
                      id="imono"
                      type="text"
                      name="imoNo"
                      placeholder={t("content.IMOno")}
                      value={this.state.shipInfo.imoNo}
                      onChange={(e) => this.handleInputChange(e)}
                    ></input>
                  </div>
                  <div className={showSidePane ? "col-lg-6 mt-1" : "col-lg-4 mt-1"}>
                    <label className="form-label required">{t("TopPaneContent.Flag")}</label>
                    <br></br>
                    <select
                      id="flagname"
                      className="form-control"
                      name="flag"
                      value={this.state.shipInfo.flag}
                      onChange={(e) => this.handleInputChange(e)}
                    >
                      <option value="">{t("ShipManagementContent.SelectFlag")}</option>
                      {flagList &&
                        flagList.map((flagname) => (
                          <option value={flagname}>{flagname}</option>
                        ))}
                    </select>
                  </div>
                  <div className={showSidePane ? "col-lg-6 mt-1" : "col-lg-4 mt-1"}>
                    <label className="form-label required">{t("TopPaneContent.Class")}</label>
                    <br></br>
                    <Multiselect
                      id="selectclass"
                      options={this.state.selectClass.length === this.state.maxClassselect ? [] : ClassList}
                      isObject={false}
                      emptyRecordMsg={this.state.selectClass.length === this.state.maxClassselect
                        ? "Only two classes are allowed to select" : "No options available"}
                      style={{
                        option: {
                          "margin-right": 0,
                          display: "block",
                          "font-weight": "normal",
                        },
                        chips: { "background-color": "#1a3464" },
                      }}
                      onSelect={(item) => this.onSelectChange(item)}
                      onRemove={(item) => this.onRemoveChange(item)}
                      showArrow={true}
                      selectedValues={this.state.selectClass}
                      placeholder={
                        this.state.selectClass && this.state.selectClass.length ? "" : "Select Class"}
                      closeIcon="cancel"
                    />
                  </div>
                  <div className={showSidePane ? "col-lg-6 mt-1" : "col-lg-4 mt-1"}>
                    <label className="form-label">{t("TopPaneContent.TypeofShip")}</label>
                    <br></br>
                    <select
                      className="form-control"
                      name="typeOfShip"
                      value={this.state.shipInfo.typeOfShip}
                      onChange={(e) => this.handleInputChange(e)}
                    >
                      <option value="">{t("ShipManagementContent.SelectTypeofShip")}</option>
                      {TypeofShipList &&
                        TypeofShipList.list.map((typeofship) => (
                          <option value={typeofship}>{typeofship}</option>
                        ))}
                    </select>
                  </div>
                  <div className={showSidePane ? "col-lg-6 mt-1" : "col-lg-4 mt-1"}>
                    <label className="form-label fontstyle required"> {t("ShipEquipmentStatusScreen.DateofBuild")} </label>
                    <br></br>
                    <div
                      className="input-group add-on date datepicker"
                      data-date-format="yyyy-mm-dd"
                    >
                      <input
                        type="text"
                        id="dateofbuild"
                        className="form-control date-picker"
                        placeholder={t("ShipEquipmentStatusScreen.DateofBuild")}
                        value={this.state.shipInfo.dateOfBuild}
                      ></input>
                      <DatePicker
                        showMonthDropdown
                        showYearDropdown
                        onChange={this.handleDateofBuild}
                        open={this.state.DatePickerIsOpen}
                        onClickOutside={this.handleBlur}
                        dropdownMode="select"
                        popperPlacement="top-end"
                        className="form-control date-picker w-5 hide-date"
                      />
                      <div
                        className="input-group-btn calendar-icon"
                        onClick={this.openDatePicker}
                      >
                        <button
                          className="btn btn-default"
                          style={{ height: "100%" }}
                        >
                          <i className="fa fa-calendar mt-1"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                  <div className={showSidePane ? "col-lg-6 mt-1" : "col-lg-4 mt-1"}>
                    <label className="form-label">{t("ShipManagementContent.GRT")}</label>
                    <br></br>
                    <input
                      className="form-control"
                      type="text"
                      name="grt"
                      placeholder={t("ShipManagementContent.GRT")}
                      value={this.state.shipInfo.grt}
                      onChange={(e) => this.handleInputChange(e)}
                    ></input>
                  </div>
                  <div className={showSidePane ? "col-lg-6 mt-1" : "col-lg-4 mt-1"}>
                    <label className="form-label">{t("ShipManagementContent.DeadWeight")}</label>
                    <br></br>
                    <input
                      className="form-control"
                      type="text"
                      name="deadWeight"
                      placeholder={t("ShipManagementContent.DeadWeight")}
                      value={this.state.shipInfo.deadWeight}
                      onChange={(e) => this.handleInputChange(e)}
                    ></input>
                  </div>
                  <div className={showSidePane ? "col-lg-6 mt-1" : "col-lg-4 mt-1"}>
                    <label className="form-label fontstyle required"> {t("EquipmentSeviceDetailsScreen.EnrollmentDate")} </label>
                    <br></br>
                    <div
                      className="input-group add-on date datepicker"
                      data-date-format="yyyy-mm-dd"
                    >
                      <input
                        type="text"
                        id="enrollmentdate"
                        className="form-control date-picker"
                        placeholder={t("EquipmentSeviceDetailsScreen.EnrollmentDate")}
                        value={this.state.shipInfo.enrollmentDate}
                      ></input>
                      <DatePicker
                        showMonthDropdown
                        showYearDropdown
                        onChange={this.handleEnrollmentDate}
                        open={this.state.EnrollmentDatePickerIsOpen}
                        onClickOutside={this.handleBlur}
                        dropdownMode="select"
                        popperPlacement="top-end"
                        className="form-control date-picker w-5 hide-date"
                      />
                      <div
                        className="input-group-btn calendar-icon"
                        onClick={this.openEnrollmentDatePicker}
                      >
                        <button
                          className="btn btn-default"
                          style={{ height: "100%" }}
                        >
                          <i className="fa fa-calendar mt-1"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                  <div className={showSidePane ? "col-lg-6 mt-1" : "col-lg-4 mt-1"}>
                    <label className="form-label">{t("ShipEquipmentStatusScreen.FirePlan")}</label>
                    <br></br>
                    <div class="input-group ">
                      <div class="input-group-prepend">
                        <span class="input-group-text">
                          {t("CommonText.BrowseFile")}
                          <input
                            type="file"
                            id="files"
                            name="fileName"
                            style={{ marginRight: 40 }}
                            onChange={(e) => this.handleInputChange(e)}
                            onClick={(event) => {
                              event.currentTarget.value = null;
                            }}
                          />
                        </span>
                      </div>
                      <input
                        type="text"
                        class="form-control"
                        placeholder={t("CommonText.Nofilechoosen")}
                        value={this.state.fileName}
                      />
                      {this.state.fileName ? (
                        <div
                          class="input-group-append"
                          style={{ cursor: "pointer" }}
                        >
                          <i
                            class="fa fa-times input-group-text"
                            aria-hidden="true"
                            onClick={() => this.ClearInput()}
                          ></i>
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                    <span id="FileErrMsg" className="spanErrMsg"></span>
                  </div>
                  <div className={showSidePane ? "col-lg-6 mt-1" : "col-lg-4 mt-1"}>
                    <label className="form-label">{t("ShipEquipmentStatusScreen.ContractAttachment")}</label>
                    <br></br>
                    <div class="input-group ">
                      <div class="input-group-prepend">
                        <span class="input-group-text">
                          {t("CommonText.BrowseFile")}
                          <input
                            type="file"
                            id="files"
                            name="attachmentName"
                            style={{ marginRight: 40 }}
                            onChange={(e) => this.handleAttachmentInputChange(e)}
                            onClick={(event) => {
                              event.currentTarget.value = null;
                            }}
                          />
                        </span>
                      </div>
                      <input
                        type="text"
                        class="form-control"
                        placeholder={t("CommonText.Nofilechoosen")}
                        value={this.state.attachmentName}
                      />
                      {this.state.attachmentName ? (
                        <div
                          class="input-group-append"
                          style={{ cursor: "pointer" }}
                        >
                          <i
                            class="fa fa-times input-group-text"
                            aria-hidden="true"
                            onClick={() => this.ClearAttachmentInput()}
                          ></i>
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                    <span id="AttachmentErrMsg" className="spanErrMsg"></span>
                  </div>
                  <div
                    className={showSidePane ? "col-lg-6 mt-1" : "col-lg-4 mt-1"}
                  >
                    <label className="form-label">
                      {t("ShipEquipmentStatusScreen.IsInContract")}
                    </label>
                    <br></br>
                    <input type="checkbox" className="checkbox-style" checked={this.state.shipInfo.isContract} onChange={(event) => this.handleContractCheckChange(event)} />
                    {/* <span id="AttachmentErrMsg" className="spanErrMsg"></span> */}
                  </div>
                </div>
              </div>
              <div className="search-filter-box">
                <div
                  className="card MM-card-header mb-0"
                  style={{ backgroundColor: "white" }}
                >
                  <div
                    className="card-body"
                    style={{
                      padding: "0rem",
                      backgroundColor: "#1a3464",
                      color: "white",
                    }}
                  >
                    <h5
                      className="card-title ml-2 mt-2"
                      style={{ color: "092a51" }}
                    >
                      {t("ShipManagementContent.ShipContactDetails")}
                    </h5>
                  </div>
                </div>
                <div className="row search-filter-box">
                  <div className={showSidePane ? "col-lg-6" : "col-lg-4"}>
                    <label className="form-label fontstyle required"> {t("DashboardMoreInformation.ShipEmail")}</label>
                    <br></br>
                    <input
                      className="form-control"
                      type="email"
                      id="shipemail"
                      name="shipEmail"
                      placeholder={t("DashboardMoreInformation.ShipEmail")}
                      value={this.state.shipInfo.shipEmail}
                      onChange={(e) => this.handleInputChange(e)}
                    ></input>
                  </div>
                  <div className={showSidePane ? "col-lg-6" : "col-lg-4"}>
                    <label className="form-label">{t("DashboardMoreInformation.ShipContactNumber1")}</label>
                    <br></br>
                    <input
                      className="form-control"
                      type="text"
                      pattern="[0-9]*"
                      name="phone1"
                      placeholder={t("DashboardMoreInformation.ShipContactNumber1")}
                      value={this.state.shipInfo.phone1}
                      onChange={(e) => this.handleInputChange(e)}
                    ></input>
                  </div>
                  <div className={showSidePane ? "col-lg-6" : "col-lg-4"}>
                    <label className="form-label">{t("DashboardMoreInformation.ShipContactNumber2")}</label>
                    <br></br>
                    <input
                      className="form-control"
                      type="text"
                      pattern="[0-9]*"
                      name="phone2"
                      placeholder={t("DashboardMoreInformation.ShipContactNumber2")}
                      value={this.state.shipInfo.phone2}
                      onChange={(e) => this.handleInputChange(e)}
                    ></input>
                  </div>
                  <div className={showSidePane ? "col-lg-6" : "col-lg-4"}>
                    <label className="form-label">
                      {t("DashboardMoreInformation.InvoiceForwardingEmail")}
                    </label>
                    <br></br>
                    <input
                      className="form-control"
                      type="email"
                      name="invoiceForwardingEmail"
                      placeholder={t("DashboardMoreInformation.InvoiceForwardingEmail")}
                      value={this.state.shipInfo.invoiceForwardingEmail}
                      onChange={(e) => this.handleInputChange(e)}
                    ></input>
                  </div>
                  <div className={showSidePane ? "col-lg-6" : "col-lg-4"}>
                    <label className="form-label">{t("DashboardMoreInformation.VesselGroupEmail")}</label>
                    <br></br>
                    <input
                      className="form-control"
                      type="email"
                      name="vesselGroupEmail"
                      placeholder={t("DashboardMoreInformation.VesselGroupEmail")}
                      value={this.state.shipInfo.vesselGroupEmail}
                      onChange={(e) => this.handleInputChange(e)}
                    ></input>
                  </div>
                </div>
              </div>
              <div className="search-filter-box">
                <div
                  className="card MM-card-header mb-0"
                  style={{ backgroundColor: "white" }}
                >
                  <div
                    className="card-body"
                    style={{
                      padding: "0rem",
                      backgroundColor: "#1a3464",
                      color: "white",
                    }}
                  >
                    <h5
                      className="card-title ml-2 mt-2"
                      style={{ color: "092a51" }}
                    >
                      {t("DashboardMoreInformation.CompanyDetails")}
                    </h5>
                  </div>
                </div>
                <div className="row search-filter-box">
                  <div className={showSidePane ? "col-lg-6" : "col-lg-4"}>
                    <label className="form-label fontstyle required">{t("ShipManagementContent.CompanyName")}</label>
                    <br></br>
                    <select
                      className="form-control"
                      id="companyname"
                      name="companyName"
                      value={this.state.shipInfo.companyName}
                      onChange={(e) => this.handleCompanyInputChange(e)}
                    >
                      <option value="">{t("ShipManagementContent.SelectCompanyName")}</option>
                      {ClientNameList &&
                        ClientNameList.clients.map((clientname) => (
                          <option value={clientname}>{clientname}</option>
                        ))}
                    </select>
                  </div>
                  <div className={showSidePane ? "col-lg-6 " : "col-lg-8"}></div>
                  <div className={showSidePane ? "col-lg-6" : "col-lg-4"}>
                    <label className="form-label">{t("ShipManagementContent.FleetManager")}</label>
                    {/* <br></br> */}
                    <Multiselect
                      options={ClientUsersList?.fleetManagers ?? []}
                      id="ServiceType"
                      showArrow={true}
                      isObject={false}
                      style={{
                        option: {
                          marginRight: 0,
                          display: "block",
                          fontWeight: "normal",
                        },
                        chips: { "background-color": "#1a3464" },
                      }}
                      onSelect={(item) => this.handleCompanyInputChange1("fleetmanager", item)}
                      onRemove={(item) => this.handleCompanyInputChange1("fleetmanager", item)}
                      selectedValues={this.state.fleetmanager}
                      placeholder={
                        this.state.fleetmanager && this.state.fleetmanager.length ? "" : "Select fleet manager"}
                      closeIcon="cancel"
                    />
                    {/* <select
                      className="form-control"
                      name="fleetmanager"
                      value={this.state.fleetmanager}
                      onChange={(e) => this.handleCompanyInputChange(e)}
                    >
                      <option value="">{t("ShipManagementContent.SelectFleetManager")}</option>
                      {ClientUsersList && ClientUsersList.fleetManagers ? (
                        ClientUsersList.fleetManagers.map(
                          (fleetmanagername) => (
                            <option value={fleetmanagername}>
                              {fleetmanagername}
                            </option>
                          )
                        )
                      ) : (
                        <option value=""></option>
                      )}
                    </select> */}
                  </div>
                  <div className={showSidePane ? "col-lg-6" : "col-lg-4"}>
                    <label className="form-label">
                      {t("ShipManagementContent.TechnicalSuperintendent")}
                    </label>
                    {/* <br></br> */}
                    <Multiselect
                      options={ClientUsersList?.superintendents ?? []}
                      id="ServiceType"
                      showArrow={true}
                      isObject={false}
                      style={{
                        option: {
                          marginRight: 0,
                          display: "block",
                          fontWeight: "normal",
                        },
                        chips: { "background-color": "#1a3464" },
                      }}
                      onSelect={(item) => this.handleCompanyInputChange1("superintendent", item)}
                      onRemove={(item) => this.handleCompanyInputChange1("superintendent", item)}
                      selectedValues={this.state.superintendent}
                      placeholder={
                        this.state.superintendent && this.state.superintendent.length ? "" : "Select superintendent"}
                      closeIcon="cancel"
                    />
                    {/* <select
                      className="form-control"
                      name="superintendent"
                      value={this.state.superintendent}
                      onChange={(e) => this.handleCompanyInputChange(e)}
                    >
                      <option value="">{t("ShipManagementContent.SelectTechnicalSuperintendent")}</option>
                      {ClientUsersList && ClientUsersList.superintendents ? (
                        ClientUsersList.superintendents.map(
                          (superintendentname) => (
                            <option value={superintendentname}>
                              {superintendentname}
                            </option>
                          )
                        )
                      ) : (
                        <option value=""></option>
                      )}
                    </select> */}
                  </div>
                  <div className={showSidePane ? "col-lg-6" : "col-lg-4"}>
                    <label className="form-label">{t("ShipManagementContent.TechnicalExecutive")}</label>
                    <Multiselect
                      options={ClientUsersList?.technicalExecutives ?? []}
                      id="ServiceType"
                      showArrow={true}
                      isObject={false}
                      style={{
                        option: {
                          marginRight: 0,
                          display: "block",
                          fontWeight: "normal",
                        },
                        chips: { "background-color": "#1a3464" },
                      }}
                      onSelect={(item) => this.handleCompanyInputChange1("technicalexecutive", item)}
                      onRemove={(item) => this.handleCompanyInputChange1("technicalexecutive", item)}
                      selectedValues={this.state.technicalexecutive}
                      placeholder={
                        this.state.technicalexecutive && this.state.technicalexecutive.length ? "" : "Select technical executive"}
                      closeIcon="cancel"
                    // value={this.state.searchData.ServiceType}
                    />
                    {/* <br></br>
                    <select
                      className="form-control"
                      name="technicalexecutive"
                      value={this.state.technicalexecutive}
                      onChange={(e) => this.handleCompanyInputChange(e)}
                    >
                      <option value="">{t("ShipManagementContent.SelectTechnicalExecutive")}</option>
                      {ClientUsersList &&
                        ClientUsersList.technicalExecutives ? (
                        ClientUsersList.technicalExecutives.map(
                          (executivename) => (
                            <option value={executivename}>
                              {executivename}
                            </option>
                          )
                        )
                      ) : (
                        <option value=""></option>
                      )}
                    </select> */}
                  </div>
                </div>
              </div>
              {/* <div className="search-filter-box">
                <div
                  className="card MM-card-header mb-0"
                  style={{ backgroundColor: "white" }}
                >
                  <div
                    className="card-body"
                    style={{
                      padding: "0rem",
                      backgroundColor: "#1a3464",
                      color: "white",
                    }}
                  >
                    <h5
                      className="card-title ml-2 mt-2"
                      style={{ color: "092a51" }}>
                      {t("ShipManagementContent.Contract")}
                    </h5>
                  </div>
                </div>
                <div className="row search-filter-box">
                  <div className={showSidePane ? "col-lg-6" : "col-lg-4"}>
                    <label className="form-label">{t("ShipManagementContent.ContractName")}</label>
                    <br></br>
                    <input
                      className="form-control"
                      name="contractName"
                      value={this.state.shipInfo.contractName}
                      placeholder={t("ShipManagementContent.ContractName")}
                      onChange={(e) => this.handleContractInputChange(e)}
                      readOnly
                    ></input>
                  </div>
                  <div className={showSidePane ? "col-lg-6" : "col-lg-8"}>
                    <label className="form-label">{t("ShipManagementContent.ContractStatus")}</label>
                    <br></br>
                    <div className="row col-sm-12">
                      <div className="radio">
                        <input
                          type="radio"
                          name="pending"
                          checked={this.state.pending}
                          onChange={(e) => this.handleContractInputChange(e)}
                        ></input>
                        <span className="ml-1 mr-3">{t("ShipManagementContent.Pending")}</span>
                      </div>
                      <div className="radio">
                        <input
                          type="radio"
                          name="active"
                          checked={this.state.active}
                          onChange={(e) => this.handleContractInputChange(e)}
                        ></input>
                        <span className="ml-1 mr-3">{t("ShipManagementContent.Active")}</span>
                      </div>
                      <div className="radio">
                        <input
                          type="radio"
                          name="terminated"
                          checked={this.state.terminated}
                          onChange={(e) => this.handleContractInputChange(e)}
                        ></input>
                        <span className="ml-1 mr-3">{t("ShipManagementContent.Terminated")}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div> */}
              <div className="search-filter-box">
                <div
                  className="card MM-card-header"
                  style={{ backgroundColor: "white" }}
                >
                  <div
                    className="card-body flex"
                    style={{
                      padding: "0rem",
                      backgroundColor: "#1a3464",
                      color: "white",
                    }}>
                    <h5
                      className="card-title ml-2 mt-2"
                      style={{ color: "092a51" }}>
                      {t("ShipManagementContent.AssignUsers")}
                    </h5>
                    {/*   <div
                      className="m-1 flex"
                      onClick={() => this.showEquipmentSidePane()}
                    >
                      <AddIcon />
                    </div> */}
                  </div>
                </div>
                <div className=" row search-filter-box">
                  <div className={showSidePane ? "col-lg-6" : "col-lg-4"}>
                    <label className="form-label">
                      {t("ShipManagementContent.Coordinator")}
                    </label>
                    <br></br>
                    <Multiselect
                      options={CoordinatorList ?? []}
                      id="ServiceType"
                      showArrow={true}
                      isObject={true}
                      displayValue="name"
                      avoidHighlightFirstOption={true}
                      style={{
                        option: {
                          marginRight: 0,
                          display: "block",
                          fontWeight: "normal",
                        },
                        chips: { "background-color": "#1a3464" },
                      }}
                      onSelect={(item) => this.handleCompanyInputChange1("grantAdmins", item)}
                      onRemove={(item) => this.handleCompanyInputChange1("grantAdmins", item)}
                      selectedValues={this.state.grantAdmins}
                      placeholder={
                        this.state.grantAdmins && this.state.grantAdmins.length ? "" : "Select Co-ordinator"}
                      closeIcon="cancel"
                    />
                    {/* <select
                      className="form-control"
                      name="grantAdminId"
                      value={this.state.shipInfo.grantAdminId}
                      onChange={(e) => this.handleCompanyInputChange(e)}
                    >
                      <option value="">{t("ShipManagementContent.SelectCoordinator")}</option>
                      {CoordinatorList ? (
                        CoordinatorList?.map(
                          (coordinatorname) => (
                            <option value={coordinatorname.id}>
                              {coordinatorname.name}
                            </option>
                          )
                        )
                      ) : (
                        <option value=""></option>
                      )}
                    </select> */}
                  </div>
                  <div className={showSidePane ? "col-lg-6" : "col-lg-4"}>
                    <label className="form-label">{t("ShipManagementContent.Approver")}</label>
                    <br></br>
                    <select
                      style={{ height: '41px' }}
                      className="form-control"
                      name="approverId"
                      value={this.state.shipInfo.approverId}
                      onChange={(e) => this.handleCompanyInputChange(e)}
                    >
                      <option value="">{t("ShipManagementContent.SelectApprover")}</option>
                      {ApproverList ? (
                        ApproverList?.map(
                          (approvername) => (
                            <option value={approvername.id}>
                              {approvername.name}
                            </option>
                          )
                        )
                      ) : (
                        <option value=""></option>
                      )}
                    </select>
                  </div>
                  {/*    {this.renderEquipmentCard()} */}
                </div>
                {/*  <div className="search-filter-box">
                  {this.props.EquipmentArray && this.props.EquipmentArray.length
                    ? this.renderEquipmentCard()
                    : null}
                </div> */}
              </div>
              <div className="search-filter-box">
                <div
                  className="card MM-card-header"
                  style={{ backgroundColor: "white" }}
                >
                  <div
                    className="card-body flex"
                    style={{
                      padding: "0rem",
                      backgroundColor: "#1a3464",
                      color: "white",
                    }}
                  >
                    <h5
                      className="card-title ml-2 mt-2"
                      style={{ color: "092a51" }}
                    >
                      {t("ComplianceandBudgetScreen.Equipments")}
                    </h5>
                    <div
                      className="m-1 flex"
                      onClick={() => this.showEquipmentSidePane()}
                    >
                      <AddIcon />
                    </div>
                  </div>
                </div>
                <div className="search-filter-box">
                  {this.props.EquipmentArray && this.props.EquipmentArray.length
                    ? this.renderEquipmentCard()
                    : null}
                </div>
              </div>
              <div className="pb-4 pl-4 pr-4">
                <div className="search-btn-col" style={{ textAlign: "end" }}>
                  {/*     <button
                    className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                    type="submit"
                    onClick={() => this.AssignUsers()}>
                    {" "}
                    Assign Users{" "}
                  </button> */}
                  <button
                    className="btn btn-primary text-uppercase txtside-btn txtht-btn blue ml-3"
                    type="submit"
                    onClick={() => this.UpdateShip()}
                  >
                    {" "}
                    {t("EquipmentServiceTypes.Update")}{" "}
                  </button>
                  <button
                    className="btn btn-light text-uppercase txtside-btn txtht-btn ml-3"
                    type="button"
                    onClick={() => this.CancelUpdateship()}
                  >
                    {" "}
                    {t("ComplianceandBudgetScreen.Cancel")}{" "}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
  renderEquipmentCard = () => {
    const { showSidePane, EquipmentArray, t } = this.props;
    const isArabic = i18n.language === 'arab';
    return (
      <>
        {EquipmentArray &&
          EquipmentArray.map((item) => (
            <div
              className="card MM-card-content mb-2 click"
              style={{
                backgroundColor: "#f0f0f0",
                overflow: "hidden",
                position: "relative",
              }}
            >
              <div className="p-3">
                <div className="resource-list-auth-date">
                  <div className="row">
                    <div className={"col-sm-9 col-md-10 col-9 m-auto"}>
                      <div className="row">
                        <div className="col-sm-12 col-md-12 py-1">
                          <h6 className="resource-list-title m-0">
                            {item.equipment}
                          </h6>
                        </div>
                        <div className={"col-md-4 col-sm-6 py-1"}>
                          <span>
                            <strong>{t("TopPaneContent.Category")}: </strong>
                            {item.category}{" "}
                          </span>
                        </div>
                        <div className={"col-md-4 col-sm-6 py-1"}>
                          <span>
                            <strong>{t("ComplianceandBudgetScreen.Type")}: </strong>
                            {item.equipmentType}
                          </span>
                        </div>
                        <div className={"col-md-4 col-sm-6 py-1"}>
                          <span className={`${isArabic ? 'arabic_ship' : ''}`}>
                            <strong>{t("ShipEquipmentStatusScreen.ManufacturingDate")} </strong>
                            <strong>:</strong>

                          </span>
                          {item.manufracturingDate
                            ? Moment(
                              new Date(Date.parse(item.manufracturingDate))
                            ).format("DD-MMM-YYYY")
                            : ""}
                        </div>
                        {item?.equipment.toLowerCase().includes("lifeboat") ?
                          <>
                            <div className={"col-md-4 col-sm-6 py-1"}>
                              <span>
                                <strong>{t("EditEquipmentScreenContent.LifeboatMake")} :{" "} </strong>
                                {item.lifeboatMake}{" "}
                              </span>
                            </div>
                            <div className={"col-md-4 col-sm-6 py-1"}>
                              <span>
                                <strong> {t("EditEquipmentScreenContent.Davit/winchMake")} :{" "} </strong>
                                {item.davitwinchMake}{" "}
                              </span>
                            </div>
                            <div className={"col-md-4 col-sm-6 py-1"}>
                              <span>
                                <strong> {t("EditEquipmentScreenContent.LifeboatModel")} :{" "} </strong>
                                {item.lifeboatModel}{" "}
                              </span>
                            </div>
                            <div className={"col-md-4 col-sm-6 py-1"}>
                              <span>
                                <strong> {t("EditEquipmentScreenContent.LifeboatRelease")} :{" "} </strong>
                                {item.lifeboatRelease}{" "}
                              </span>
                            </div>
                          </>
                          : item?.equipment.toLowerCase().includes("rescue boat") ?
                            <>
                              <div className={"col-md-4 col-sm-6 py-1"}>
                                <span>
                                  <strong>{t("EditEquipmentScreenContent.rescueboatMake")} :{" "} </strong>
                                  {item.rescueboatMake}{" "}
                                </span>
                              </div>
                              <div className={"col-md-4 col-sm-6 py-1"}>
                                <span>
                                  <strong>{t("EditEquipmentScreenContent.rescueboatDavit/winchMake")} :{" "} </strong>
                                  {item.rescueboatdavitwinchMake}{" "}
                                </span>
                              </div>
                              <div className={"col-md-4 col-sm-6 py-1"}>
                                <span>
                                  <strong>{t("EditEquipmentScreenContent.rescueboatModel")} :{" "} </strong>
                                  {item.rescueboatModel}{" "}
                                </span>
                              </div><div className={"col-md-4 col-sm-6 py-1"}>
                                <span>
                                  <strong> {t("EditEquipmentScreenContent.rescueboatRelease")} :{" "} </strong>
                                  {item.rescueboatRelease}{" "}
                                </span>
                              </div>
                            </> : <>
                              <div className={"col-md-4 col-sm-6 py-1"}>
                                <span className={`${isArabic ? 'arabic' : ''}`}>
                                  <strong>{t("ShipEquipmentStatusScreen.Make")}  </strong>
                                  <strong>:</strong>
                                  {item.make}{" "}
                                </span>
                              </div>
                              <div className={"col-md-4 col-sm-6 py-1"}>
                                <span className={` ${isArabic ? 'arabic_ship' : ''}`}>
                                  <strong>{t("ShipEquipmentStatusScreen.Model")}  </strong>
                                  <strong>:</strong>
                                  {item.model}{" "}
                                </span>
                              </div></>}
                        <div className={"col-md-4 col-sm-6 py-1"}>
                          <span className={`${isArabic ? 'arabic' : ''}`}>
                            <strong>{t("ShipEquipmentStatusScreen.Quantity")} </strong>
                            <strong>:</strong>
                            {item.quantity > 0 ? item.quantity : ""}
                          </span>
                        </div>
                        <div className={"col-md-4 col-sm-6 py-1"}>
                          <span className={`${isArabic ? 'arabic' : ''}`}>
                            <strong>{t("ShipEquipmentStatusScreen.Unit-Quantity")} </strong>
                            <strong>:</strong>
                            {item.unit}
                          </span>
                        </div>
                        <div className={"col-md-4 col-sm-6 py-1"}>
                          <span className={`${isArabic ? 'arabic_ship' : ''}`}>
                            <strong>{t("ShipEquipmentStatusScreen.Capacity")} / {t("ShipEquipmentStatusScreen.Size")} </strong>
                            <strong>:</strong>

                          </span>
                          {item.capacity}
                        </div>
                      </div>
                    </div>
                    <div className={"col-sm-3 col-md-2 col-3 m-auto"}>
                      <div
                        className="text-right"
                        style={{ marginLeft: "-5px" }}
                      >
                        <OverlayTrigger
                          placement="bottom"
                          delay={{ show: 250, hide: 400 }}
                          overlay={this.renderedit()}
                        >
                          <i
                            className="fa fa-edit fa-2x fa-lg px-1 m-1"
                            onClick={() => this.EditEquipment(item)}
                          ></i>
                        </OverlayTrigger>
                        <OverlayTrigger
                          placement="bottom"
                          delay={{ show: 250, hide: 400 }}
                          overlay={this.renderdelete()}
                        >
                          <i
                            className="fa fa-trash fa-2x px-2 m-1"
                            onClick={() => this.DeleteEquipment(item)}
                          ></i>
                        </OverlayTrigger>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
      </>
    );
  };

  DeleteEquipment(item) {
    const { match, dispatch, t } = this.props;
    const { params } = match;
    const { id } = params;
    confirmAlert({
      message: `${t("confirmAlertMessage.DeleteMsg")}`,
      buttons: [
        {
          label: `${t("confirmAlertMessage.Yes")}`,
          onClick: () => {
            let EquipArray = [];
            let deleteEquip = {
              shipId: item.shipId,
              equipmentId: item.equipmentId,
              shipEquipmentId: item.shipEquipmentId,
              equipmentContractTypeId: item.equipmentContractTypeId ? item.equipmentContractTypeId : 0,
              equipment: item.equipment,
              recentlyUpdated: true,
              manufracturingDate: item.manufracturingDate,
              make: item.make,
              model: item.model,
              quantity: item.quantity,
              unit: item.unit,
              equipmentType: item.equipmentType,
              capacity: item.capacity,
              category: item.category,
              serviceDetails: item.serviceDetails,
              modifiedBy: currentUser.name,
              isDeleted: true,
            };
            EquipArray.push(deleteEquip);
            let url = `${API.postShipEquipment}`;
            axios
              .put(url, EquipArray)
              .then((response) => {
                dispatch(getShipEquipmentDetails(id));
                dispatch({
                  type: "UpdateEquipmentDetailSuccess",
                  data: response.data,
                });
              })
              .catch((error) => {
                dispatch({
                  type: "UpdateEquipmentDetailFailure",
                  data: "error",
                });
              });
          },
        },
        {
          label: `${t("confirmAlertMessage.No")}`,
          onClick: () => { },
        },
      ],
    });
  }

  EditEquipment(item) {
    this.props.dispatch({ type: "editEquipment", data: true });
    this.props.dispatch({ type: "ShowSidePan", data: true });
    this.props.dispatch({ type: "getEquipmentDetails", data: item });
    this.props.history.push(
      `/Home/ShipManagementEditItem/${this.props.match.params.id}/Equipment`
    );
    window.scrollTo(0, 0);
  }

  showEquipmentSidePane() {
    this.props.dispatch({ type: "ShowSidePan", data: true });
    this.props.dispatch({ type: "editEquipment", data: false });
    this.props.dispatch({ type: "getEquipmentDetails", data: "" });
    this.props.dispatch({ type: "getEquipmentDropDownListSuccess", data: null });
    this.props.dispatch({ type: "getMakesListEquipmentSuccess", data: [] });
    this.props.dispatch({ type: "getModelsListEquipmentSuccess", data: [] });
    this.props.dispatch({ type: "getServiceTypeListSuccess", data: null });
    this.props.dispatch({ type: "getServiceTypeIntervalListSuccess", data: null });
    this.props.dispatch({ type: "getServiceTypeIntervalListFlagSuccess", data: null })
    this.props.history.push(
      `/Home/ShipManagementEditItem/${this.props.match.params.id}/NewEquipment`
    );
    this.props.dispatch({ type: "annualAttachmentUploadSuccess", data: "" });
    this.props.dispatch({ type: "getShipServiceProviderIDSuccess", data: [] });
    window.scrollTo(0, 0);
  }
}

function mapDispatchToProps(dispatch) {
  return {
    dispatch,
  };
}

function mapStateToProps(state) {
  return {
    FirePlanAttachment: state.lookupReducer.FirePlanAttachment || null,
    ShipContractAttachment: state.lookupReducer.ShipContractAttachment || null,
    flagList: state.MasterScreenReducer.flagList,
    ClientUsersList: state.MasterScreenReducer.ClientUsersList,
    ClientNameList: state.MasterScreenReducer.ClientNameList,
    showSidePane: state.SidePanReducer.sidePan,
    EquipmentArray: state.MasterScreenReducer.ShipEquipmentDetails,
    ClassList: state.MasterScreenReducer.ClassList,
    companyName: state.MasterScreenReducer.companyName,
    ShipDetails: state.MasterScreenReducer.ShipManagementDetails,
    TypeofShipList: state.MasterScreenReducer.TypeofShipList,
    ApproverList: state.ShipEquipmentReducer.ApproverList,
    CoordinatorList: state.ShipEquipmentReducer.CoordinatorList
  };
}
export default withTranslation()(withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ShipManagementEditItem)));
